import { Component, ComponentInterface, h, Prop } from '@stencil/core';
import { Language } from '../../../models/Language';
import { I18nUtil } from '../../../utils/i18n/I18nUtil';
import { BahfEvents } from '../types/bahf-event.types';

/**
 * @internal
 */
@Component({
  tag: 'bahf-header-lang-switch-list-item',
  styleUrl: '',
  shadow: false,
  scoped: true,
})
export class BahfHeaderLangSwitchListItem implements ComponentInterface {
  @Prop() active: boolean;
  @Prop() mobile: boolean = false;
  @Prop() language: Language;
  @Prop() srSelectionLabel: string;

  handleLanguageClick(event: MouseEvent) {
    // If no href is provided, prevent default behavior (page navigation)
    if (!this.language?.href) {
      event.preventDefault();

      // Remove 'lang' query parameter from URL if it exists
      const url = new URL(window.location.href);
      if (url.searchParams.has('lang')) {
        url.searchParams.delete('lang');
        window.history.replaceState({}, '', url.toString());
      }

      I18nUtil.setLanguageCookie(this.language.code);

      window.dispatchEvent(new CustomEvent(BahfEvents.UPDATE_LANGUAGES));
    } else {
      I18nUtil.setLanguageCookie(this.language.code);
    }
  }

  render() {
    return (
      <a
        onClick={(event) => this.handleLanguageClick(event)}
        href={this.language?.href || '#'}
        class={`${this.mobile ? '' : 'dropdown-item'} ${this.active ? 'active' : ''}`}
        role="menuitem"
      >
        {this.language.label}
        {this.active ? <span class="sr-only">{this.srSelectionLabel}</span> : null}
      </a>
    );
  }
}
